export default __webpack_public_path__ + "static/media/gift-box1.fa726206.png";